import { Status, TranslatorKey } from 'models'

const keyMatchHelper: Record<keyof Status, TranslatorKey | 'blockingReason'> = {
  administrativeStatus: 'administrativeStatus',
  logisticStatus: 'vehicleInventoryStatus',
  generalStatus: 'vehicleGeneralStatus',
  auctionStatus: 'auctionStatus',
  registrationDocumentStatus: 'grayCardStatus',
  qualityControlStatus: 'qaStatus',
  blockingReason: 'blockingReason',
}

export { keyMatchHelper }
